import {Component, Inject, OnInit} from '@angular/core';
import {NotificationsService} from '../notifications.service';
import * as moment from 'moment';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/observable/empty';
import {Notifications} from '../notifications.enum';
import * as angular from 'angular';

@Component({
	selector: 'tt-missing-working-days-notification',
	templateUrl: './missing-working-days.component.html',
	styleUrls: ['./missing-working-days.component.scss']
})
export class MissingWorkingDaysNotificationComponent implements OnInit {

	private missingWorkingDays: number[] = [];
	private visible: boolean;

	constructor(private notificationsService: NotificationsService,
				@Inject('$rootScope') private rootScopeService: angular.IRootScopeService) {
	}

	ngOnInit(): void {
		this.notificationsService.getMissingWorkingDays()
			.subscribe((missingDays: number[]) => {
				this.missingWorkingDays = missingDays;
			});
	}

	isVisible(): boolean {
		return this.notificationsService.isNotificationAvailable(Notifications.MISSING_WORKING_DAYS)
			&& this.isDataPresent();
	}

	closeNotification(): void {
		this.notificationsService.closeNotification(Notifications.MISSING_WORKING_DAYS);
	}

	goToDate(date: number): void {
		const body: HTMLElement = window.document.body;
		const html: HTMLElement = window.document.documentElement;
		const scrollHeight: number = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
		window.scrollTo(0, scrollHeight);
		this.rootScopeService.$emit('goToDate', moment.utc(date).format('MM/DD/YYYY'));
	}

	public formatDay(date: number): string {
		return moment.utc(date).format('MMM DD, YYYY - dddd');
	}

	private isDataPresent(): boolean {
		return this.missingWorkingDays && this.missingWorkingDays.length > 0;
	}
}



// WEBPACK FOOTER //
// ./src/app/my-time/notifications/missing-working-days/missing-working-days.component.ts